import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface DraftBadgeProps {
    label?: string
    tone?: 'light' | 'dark'
    className?: string
}

// Marks content that has not been confirmed by the owner yet ("bestaetigt" is off in the CMS).
export const DraftBadge: FC<DraftBadgeProps> = ({ label = 'Noch nicht bestätigt', tone = 'light', className }): ReactNode => {
    return (
        <span
            className={cn(
                'type-label inline-flex items-center gap-1.5 rounded-full border border-dashed px-2.5 py-1',
                tone === 'dark' ? 'border-ember-bright/60 text-ember-bright' : 'border-ember/60 text-ember',
                className
            )}
        >
            <span aria-hidden='true' className='size-1.5 rounded-full bg-current' />
            {label}
        </span>
    )
}
